/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button, Box,Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import userServices from '../../../../commonServices/UserServices';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { RotateLeft } from '@material-ui/icons';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);

    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);

    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function RouteListing(props) {
    const screenCode = 'ROUTE';
    let encrypted = "";
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        groupID: "0",

    });
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const OperationEntitiySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
        },
        validationSchema: OperationEntitiySearchSchema,
        onSubmit: (values) => {
            trackPromise(GetAllRoutesByGroupID(values.groupID));
        },
    });

    async function GetAllRoutesByGroupID(groupID) {
        var res = await services.GetAllRoutesByGroupID(groupID);
        if (res != null) {
            setTableData(res);
        }
    }

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    useEffect(() => {
        const storedFormData = JSON.parse(sessionStorage.getItem('routeFormData'));
        const storedPage = JSON.parse(sessionStorage.getItem('routePage'));
        getPermissions(storedFormData, storedPage);
        sessionStorage.removeItem('routeFormData');
        sessionStorage.removeItem('routePage');

    }, []);

    useEffect(() => {
        setTableData([]);
    }, [formik.values.groupID]);

    async function getPermissions(storedFormData, storedPage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROUTE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        const isInitialLoading = storedFormData === null
        if (isInitialLoading) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            })
        } else {
            setValues({
                ...values,
                groupID: parseInt(storedFormData.groupID),
            })
            if (storedFormData.groupID !== 0) {
                trackPromise(GetAllRoutesByGroupID(storedFormData.groupID));
            } else {   
                setTableData([]);
            }
            if (storedPage !== null) {
                setPage(storedPage);
            }
        }
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function clearAll() {
        setPage(0);
        setTableData([]);
        sessionStorage.removeItem('routeFormData');
        sessionStorage.removeItem('routePage');
        setValues({ ...values, groupID: 1 });
    }

    function handleClick(datas) {
        setPage(0);
        sessionStorage.setItem('routeFormData', JSON.stringify(values));
        sessionStorage.setItem('routePage', JSON.stringify(page));
        encrypted = AESEncryptionParam(datas.routeID.toString());
        navigate('/dashboard/route/AddEdit/' + encrypted);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Route |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/route/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Route"
                    />
                    <FormikProvider value={formik}>

                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form enableReinitialize autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Stack width={450}>

                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            id="groupID"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    </Stack>
                                    <Grid item md={8} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Routes" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table size='small' aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Route Code</TableCell>
                                                <TableCell align="center">Route Name</TableCell>
                                                <TableCell align="center">Description</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.routeID}>
                                                    <TableCell align="center" component="th" scope="row">
                                                        {row.routeCode}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.routeName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.routeDescription ? row.routeDescription : "-"}
                                                    </TableCell>
                                                    <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick(row)}  >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}